// Email service using n8n webhook
// Die Webhook-URL wird aus der Konfiguration geladen
import env from '../config/env';

/**
 * Sendet Formulardaten an einen n8n-Webhook
 * @param {Object} formData - Die Formulardaten (name, email, subject, message)
 * @returns {Promise} - Ein Promise mit dem Ergebnis der Anfrage
 */
const sendEmail = async (formData) => {
  try {
    // Hole die Webhook-URL aus der Konfiguration
    const webhookUrl = env.n8nWebhookUrl;
    
    if (!webhookUrl) {
      console.error('Webhook URL ist nicht konfiguriert');
      throw new Error('Webhook URL ist nicht konfiguriert');
    }
    
    // Sende die Daten an den Webhook
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
        timestamp: new Date().toISOString(),
        source: 'website-contact-form'
      }),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Webhook response:', data);
    
    return {
      status: 'success',
      message: 'Nachricht erfolgreich gesendet!'
    };
  } catch (error) {
    console.error('Fehler beim Senden der Nachricht:', error);
    throw {
      status: 'error',
      message: 'Es gab ein Problem beim Senden der Nachricht. Bitte versuchen Sie es später erneut.'
    };
  }
};

export default sendEmail;
